import { useCallback, ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { calendarToggle } from "../../actions";
import { getMonthName } from "../../utils/date";
import { getIsCalendarOpen } from "../../state/isCalendarOpen.selectors";
import { getWeekVisible } from "../../state/weekVisible.selectors";
import { ArrowUp, ArrowDown } from "../generic/ArrowIcons";
import { h } from "../../h";

const MonthContainerStyled = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colorAccent};
`;

export const Month = (): ReactElement => {
    const currentDay = useSelector(getWeekVisible);
    const monthName = getMonthName(currentDay);
    const dispatch = useDispatch();
    const onClickMonth = useCallback(() => {
        dispatch(calendarToggle());
    }, [dispatch]);
    const isCalendarOpen = useSelector(getIsCalendarOpen);
    // TODO: if is calendar open
    return h(
        MonthContainerStyled,
        {
            onClick: onClickMonth,
        },
        h(`div`, {}, monthName, isCalendarOpen ? h(ArrowUp) : h(ArrowDown)),
    );
};
